import { createFileRoute } from '@tanstack/react-router'
import { requirePagePermission } from '~/features/org/guard'
import { seasonsQuery, settingsQuery, teamsQuery } from '~/features/org/queries'
import { SettingsPage } from '~/features/org/SettingsPage'

export const Route = createFileRoute('/_app/verein/einstellungen/')({
  beforeLoad: ({ context }) => requirePagePermission(context.queryClient, 'org.manage'),
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(settingsQuery),
      queryClient.ensureQueryData(teamsQuery),
      queryClient.ensureQueryData(seasonsQuery),
    ]),
  component: SettingsPage,
})
